import React from 'react'

//* Components
import Banner from './components/Banner/Banner'

//* Styles
import styles from '../../styles/Main.module.scss'

const AboutUs = () => {
  return (
    <div className={styles["page"]}>
        <Banner/>
    </div>
  )
}

export default AboutUs